export default __webpack_public_path__ + "static/media/bazelevs.fb26d2e0.svg";